<template>
    <div>
        <v-row>
            <v-col cols="12" md="7">
                <div id="app">
                    <gmap-map
                        v-show="showMap"
                        ref="map2"
                        id="map2"
                        :center="map.center"
                        :zoom="11"
                        style="width: 100%; height: 610px"
                    >
                    </gmap-map>
                </div>
            </v-col>
            <v-col cols="12" md="5">
                <b style="color:#3564bd; font-size:16px;"
                    >Total Distance: <span id="total" ref="total"></span
                ></b>
                <div class="div-scoll">
                    <div id="right-panel2" ref="right-panel2"></div>
                </div>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import DirectionsRenderer from "../../../test/components/DirectionsRenderer"
export default {
    props: ["data_map"],
    watch: {
        data_map: function(newQuestion, oldQuestion) {
            this.map_main.start.lat = ""
            this.map_main.start.lng = ""
            this.map_main.end.lat = ""
            this.map_main.end.lng = ""
            this.a_directionsService = ""
            this.a_directionsRenderer = ""
            this.wp = []
            this.fetchdata()
        },
    },
    mounted() {
        this.fetchdata()
    },
    methods: {
        fetchdata() {
            this.map_main.start.lat = parseFloat(this.data_map.lat_start)
            this.map_main.start.lng = parseFloat(this.data_map.lng_start)
            this.map_main.end.lat = parseFloat(this.data_map.lat)
            this.map_main.end.lng = parseFloat(this.data_map.lng)

            let wp_xx = eval("[" + this.data_map.waypoints + "]")

            for (let index = 0; index < wp_xx[0].length; index++) {
                this.wp.push({
                    location: {
                        lat: parseFloat(wp_xx[0][index][0]),
                        lng: parseFloat(wp_xx[0][index][1]),
                    },
                    stopover: false,
                })
            }

            // let ii = this.data_map.length - 1

            // this.data_map.map((each, i) => {
            //     if (i == 0) {
            //         this.map_main.start.lat = parseFloat(each.lat_start)
            //         this.map_main.start.lng = parseFloat(each.lng_start)
            //     }

            //     if (
            //         each.waypoints != null &&
            //         each.waypoints != "" &&
            //         each.same != "Y"
            //     ) {
            //         var wp_xx = eval("[" + each.waypoints + "]")

            // for (let index = 0; index < wp_xx[0].length; index++) {
            //     this.wp.push({
            //         location: {
            //             lat: parseFloat(wp_xx[0][index][0]),
            //             lng: parseFloat(wp_xx[0][index][1]),
            //         },
            //         stopover: false,
            //     })
            // }
            //     }

            //     if (i == ii) {
            //         this.map_main.end.lat = parseFloat(each.lat)
            //         this.map_main.end.lng = parseFloat(each.lng)
            //     } else if (each.same == "N") {
            //         this.wp.push({
            //             location: {
            //                 lat: parseFloat(each.lat),
            //                 lng: parseFloat(each.lng),
            //             },
            //         })
            //     }
            // })

            // console.log(this.map_main, "-map_main")
            // console.log(this.wp, "-wp")

            setTimeout(() => {
                // let geocoder = new google.maps.Geocoder()
                this.initMap()
            }, 1500)
        },
        initMap() {
            const map = new google.maps.Map(document.getElementById("map2"), {
                zoom: 4,
                center: { lat: 14.4847274, lng: 100.6117844 },
            })
            const directionsService = new google.maps.DirectionsService()
            const directionsRenderer = new google.maps.DirectionsRenderer({
                draggable: false,
                map,

                panel: document.getElementById("right-panel2"),
            })
            document.getElementById("right-panel2").innerHTML = ""
            this.a_directionsService = directionsService
            this.a_directionsRenderer = directionsRenderer
            directionsRenderer.addListener("directions_changed", () => {
                this.computeTotalDistance(directionsRenderer.getDirections())
            })
            this.displayRoute(
                this.map_main.start,
                this.map_main.end,
                this.a_directionsService,
                this.a_directionsRenderer
            )
        },
        displayRoute(origin, destination, service, display) {
            service.route(
                {
                    origin: origin,
                    destination: destination,

                    waypoints: this.wp,
                    travelMode: google.maps.TravelMode.DRIVING,
                    avoidTolls: true,
                },
                (result, status) => {
                    if (status === "OK") {
                        display.setDirections(result)
                    } else {
                        alert("Could not display directions due to: " + status)
                    }
                }
            )
        },
        formatKm(value) {
            let val = (value / 1).toFixed(2).replace(".", ".")
            return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
        },
        computeTotalDistance(result) {
            let total = 0
            const myroute = result.routes[0]

            for (let i = 0; i < myroute.legs.length; i++) {
                total += myroute.legs[i].distance.value
            }
            total = total / 1000
            document.getElementById("total").innerHTML =
                this.formatKm(total) + " km "
        },
    },
    data() {
        return {
            a_directionsService: "",
            a_directionsRenderer: "",
            data: {},
            showMap: true,
            map_main: {
                start: { lat: "", lng: "" },
                end: { lat: "", lng: "" },
            },
            map: {
                center: { lat: 14.4847274, lng: 100.6117844 },
            },
            wp: [],
        }
    },
}
</script>

<style scoped>
.div-scoll {
    overflow: auto;
    width: 100%;
    height: 580px;
    /* background-color: #c2eafd; */
}
</style>
